/**
 * @generated SignedSource<<516915c8d623954a5240d7912d96ebf3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserMarkerTooltip_userMarker",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userId",
      "storageKey": null
    }
  ],
  "type": "UserMarker",
  "abstractKey": null
};

node.hash = "c42be50d34f4b0b625d95910064d85f3";

module.exports = node;
